import clsx from 'clsx';
import { forwardRef, RefObject, type JSX } from 'react';
import { AriaButtonProps, FocusRing, useButton } from 'react-aria';

export type ButtonProps = {
  children: JSX.Element | JSX.Element[];
  type?: 'button' | 'submit';
  className?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
} & AriaButtonProps<'button'>;

export const buttonStyles =
  'focus:outline-hidden flex space-x-2 px-4 py-2.5 bg-transparent border-[0.5px] border-white items-center transition disabled:cursor-not-allowed disabled:opacity-30 justify-center select-none touch-none';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, disabled, style, ...props }, ref) => {
    const { buttonProps, isPressed } = useButton(
      { ...props, isDisabled: disabled },
      ref as RefObject<HTMLButtonElement>,
    );

    return (
      <FocusRing focusRingClass="ring-3 ring-orange">
        <button
          ref={ref}
          {...buttonProps}
          className={clsx(
            buttonStyles,
            'disabled:cursor-not-allowed disabled:opacity-30',
            isPressed && 'bg-white/20',
            className,
          )}
          disabled={disabled}
          style={style}
        >
          {children}
        </button>
      </FocusRing>
    );
  },
);

Button.displayName = 'Button';
